import axios, { AxiosInstance } from 'axios'

import * as config from '../../config'
import { insertAuthorizationHeader, renewTokens } from './interceptors'

export const fetch: AxiosInstance = axios.create({ baseURL: config.EMBONOR_BACKEND_FOR_FRONTEND })

fetch.interceptors.request.use(insertAuthorizationHeader, (error) => Promise.reject(error))
fetch.interceptors.response.use((response) => response, renewTokens())
